module.exports = __webpack_public_path__ + "h5/img/xicai.87731e5a.png";